// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.simx-app-notifications {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  list-style: none;
  margin: -5px 0;
  padding: 0;
}

.simx-app-notification-container {
  padding: 5px 0;
}`, "",{"version":3,"sources":["webpack://./src/app/modules/core/components/app-notifications/app-notifications.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,gBAAA;EACA,cAAA;EACA,UAAA;AACF;;AAEA;EACE,cAAA;AACF","sourcesContent":[".simx-app-notifications {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  list-style: none;\n  margin: -5px 0;\n  padding: 0;\n}\n\n.simx-app-notification-container {\n  padding: 5px 0;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
